// extracted by mini-css-extract-plugin
export var center = "_3t-2";
export var clickableRow = "_3t-5";
export var expandedRow = "_3t-7";
export var hoverable = "_3t-4";
export var left = "_3t-1";
export var right = "_3t-3";
export var row = "_3t-0";
export var selectedRow = "_3t-6";
export var summaryRow = "_3t-8";